var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 538.68 553.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#D\xE9grad\xE9_sans_nom_9);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#D\xE9grad\xE9_sans_nom_9-2);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    cx: 338.93,
    cy: 524.24,
    fx: 338.93,
    fy: 524.24,
    r: 1.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3debb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#f3debb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#e5c5a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d5a983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#a57b5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d5a983"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_9-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 9",
    cx: 29.19,
    cy: 524.44,
    fx: 29.19,
    fy: 524.44,
    r: 1144.48,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m339.7,524.06c-.1-.2-.21-.4-.32-.6-.16.26-.32.52-.49.78-.1.16,1.16-.22.81-.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m508.64,537.69c-5.43-5.87-10.73-13.57-15.64-22.02-4.12-7.51-7.65-15.37-11.3-23.16-19.01-40.69-38.04-81.37-57.06-122.05-24.4-52.19-48.81-104.38-73.22-156.57l.13-.13c-23.39-50.02-46.79-100.05-70.18-150.07-9.79-20.94-19.59-41.88-29.79-63.69-5.03,13.19-9.97,25.52-14.44,38.02-5.83,16.31-7.07,33.04-4.26,50.2,2.41,14.74,9.07,27.75,15.28,41,7.57,16.15,15.13,32.3,22.69,48.45,2.66,6.45,5.73,12.74,8.7,19.08,27.12,57.9,54.23,115.8,81.34,173.7,8.73,18.65,17.47,37.3,26.2,55.95,11.99,25.62,24.26,51.11,35.69,76.98,2.93,6.63,6.44,14.65,4.38,21.77-.5,1.73-1.92,5.05-3.61,5.57-.18.06-.39.07-.61.07-8.97-11.63-14.83-25.03-21.02-38.28-19.01-40.69-38.04-81.37-57.06-122.05-37.29-79.75-74.58-159.49-111.88-239.24-9.79-20.94-19.59-41.88-29.79-63.69-5.03,13.19-9.97,25.52-14.44,38.02-5.83,16.31-7.07,33.04-4.26,50.2,2.41,14.74,9.07,27.75,15.28,41,27.12,57.9,54.23,115.8,81.34,173.7,8.73,18.65,17.47,37.3,26.2,55.95,4.92,10.52,9.89,21.01,14.83,31.52l.07-.02c7.03,14.97,14,29.96,20.68,45.08,2.93,6.63,6.44,14.65,4.38,21.77-.5,1.73-1.92,5.05-3.61,5.57-.18.06-.39.07-.61.07-8.97-11.63-14.83-25.03-21.02-38.28-4.68-10.01-9.36-20.01-14.03-30.01l.06-.02c-14.43-30.54-28.84-61.08-43.25-91.63-25.6-54.27-51.18-108.55-76.78-162.82-6.3-13.35-12.7-26.64-19.46-40.8-3.59,9.25-6.59,17.71-10.11,25.94-4.05,9.46-6.78,18.87-8.21,28.24v-.02s-3.2,10.34-3.2,10.34c-12.35,31.39-27.36,69.13-42.36,106.22-4.17,10.68-8.48,21.66-12.91,32.9-15.93,40.43-33.51,84.45-52.53,131.62-9.81,22.43-18.36,47.12-39.26,47.14v4.74h68.71v-4.74c-13.62-.2-21.92-8.3-24.66-15.16-2.89-7.23-2.89-13.14-2.89-17.35,0-6.07,2.31-12.29,5.12-19.3,6.08-16.36,21.5-53.75,37.86-96.28h4.67c35.06,0,54.22,32.72,71.05,73.38,5.61,13.56,12.15,26.18,19.63,37.86,14.4,23.22,32.95,41.35,63.9,41.59h-.02s100.28-.2,100.28-.2c2.55,0,5.1.02,7.66.02h.45c16.12,0,32.62.08,49-.02h0s137.92,0,137.92,0v-5.06c-6.87,0-22.52-2.87-30.04-11Zm-241.29-13.65c0,7.95-2.8,24.77-23.37,24.77-45.81,0-64.03-42.53-80.39-78.53-11.68-26.17-23.83-52.35-44.4-65.9-9.35-5.61-19.63-8.41-30.85-8.41h-1.87c3.24-8.48,6.62-16.97,10.06-25.52,3-7.47,6.05-14.99,9.1-22.62,16.94-42.15,34.5-87.01,43.5-109.1.41,15.29,4.4,30.47,12.04,45.62l23.65,50.68,10.56,22.63,5.97,12.79s50.47,100.99,63.56,136.22c2.81,7.56,2.44,13.67,2.44,17.37Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.abf50b119f6d1a99df1bb2ca92a3d939.svg";
export { ForwardRef as ReactComponent };